export default __webpack_public_path__ + "static/media/dxtrade_icon-dark.9365bdf2.png";